import { mix } from "@chorda/core";
export const DropdownMenu = (props) => {
    return mix({
        css: 'dropdown-menu',
        templates: {
            content: {
                css: 'dropdown-content'
            }
        }
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        templates: {
            content: props.content
        },
    });
};
